import { Component, OnInit, ViewChild } from '@angular/core';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { NotificationType } from 'src/app/models/notification.message';
import { CostCentersService } from 'src/app/services/costcenters.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { LocationsService } from 'src/app/services/locations.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { Profile } from 'src/app/models/profile';
import { UserService } from 'src/app/services/user.service';
import { NgForm } from '@angular/forms';
import { JobRotationRequest } from 'src/app/models/requests/JobRotationVM';
import { UserInSystem } from 'src/app/models/usersInSystem';
import { FunctionDto } from 'src/app/models/FunctionDto';
import { FunctionsService } from 'src/app/services/functions.service';
import { JobRotationService } from 'src/app/services/job-rotation.service';

@Component({
  selector: 'app-new-job-rotation',
  templateUrl: './new-job-rotation.component.html',
  styleUrls: ['./new-job-rotation.component.css']
})
export class NewJobRotationComponent implements OnInit {

   @ViewChild('ngJobRotationForm') theForm!: NgForm;

  requesterFullName: string = '';
  employeeEmail: string = '';
  employeeFullName: string = '';
  isIndustrialFunction: boolean = false;
  isSameLocation: boolean = false;
  isSameUnit: boolean = false;
  isSameFunction: boolean = false;

  showHeadHR: boolean = false;
  showHRBP: boolean = false;
  showPlantMngr: boolean = false;
  showCurrentFuncDir: boolean = false;
  showReceivingFuncDir: boolean = false;
  showOHRD: boolean = false;

  requesterName: string = '';
  requesterDesignation: string = '';
  employeeName: string = '';
  employeeFunction: string = '';
  employeeUnit: string = '';
  employeeCurrentDesignation: string = '';
  employeeLocation: string = '';
  currentManager: string = '';
  currentUnitHead: string = '';
  currentSection: string = '';
  //rotationCategory: string = '';
  rotationStartDate!: Date | null;
  rotationEndDate!: Date | null;
  newDesignation: string = '';
  receivingFunction: string = '';
  receivingUnit: string = '';
  receivingManager: string = '';
  receivingUnitHead: string = '';
  receivingLocation: string = ''; 
  newSection: string = '';
  headOfHROrIndustrialRelationsToApprove: string = '';
  plantManagerApprovalToApprove: string = '';
  currentFunctionalDirectorToApprove: string = '';
  receivingFunctionalDirectorToApprove: string = '';
  ohrdToApprove: string = '';

  hrbpForNonIndustrialToApprove: string = '';

  Employees: UserInSystem[]=[];
  HRBPS:Profile[]=[];
  Managers:Profile[]=[];
  PlantManagers:Profile[]=[];
  FunctionalDirectors:Profile[]=[];
  Departments: DepartmentDto[] = [];
  Functions:FunctionDto[]=[];     //Units
  Locations: LocationDto[]=[];
  currentUser: any;
  isSubmitting: boolean = false 


  constructor(private jobRotationService: JobRotationService, private departmentService: DepartmentsService, 
    private notification: NotificationService,private tokenService: TokenService, private locationService: LocationsService, 
    private userService: UserService, private functionService:FunctionsService) 
     { 

     }

  ngOnInit(): void {
    this.LoadDropDowns();
    this.getInfo();
    console.log(this.requesterFullName );
  }

  getInfo(){
    this.currentUser = this.tokenService.getInfo();
    this.requesterFullName = this.currentUser.profile.firstName + ' ' + this.currentUser.profile.lastName;
    this.requesterDesignation = this.currentUser.profile.designationName;

  }

  async LoadDropDowns() {
    let functions = await this.functionService.getAllFunctions().toPromise();
    this.Functions = <FunctionDto[]>functions.responseData;

    let locations = await this.locationService.getLocations().toPromise();
    this.Locations = <LocationDto[]>locations.responseData;

    let resEmployees = await this.userService.getUsersInSystem().toPromise();
    this.Employees = <UserInSystem[]>resEmployees.responseData;

    let usersPro = await this.userService.getManagersUsers().toPromise();
    this.Managers = <Profile[]>usersPro.responseData;

    let plantManager = await this.userService.getManagersUsers().toPromise();
    this.PlantManagers = <Profile[]>plantManager.responseData;

    let userhrpbps = await this.userService.getHRBPS().toPromise();
    this.HRBPS = <Profile[]>userhrpbps.responseData;
    
    let ohrDirector = await this.userService.getOHRDirector().toPromise();
    let ohrDirectorRes = <Profile[]>ohrDirector.responseData;
    this.ohrdToApprove = ohrDirectorRes[0].email;
     
    let resDeparts = await this.departmentService.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;

    let directors = await this.userService.getFunctionalDirectors().toPromise();
    this.FunctionalDirectors = <Profile[]>directors.responseData;
  }

  rotationCat: any = [
    {name: "Intra-Function Rotation"},
    {name: "Intra Plant Rotation"},
    {name: "Inter-Function Rotation"},
    {name: "Inter-Plant Rotation"}
  ];

    onEmployeeSelected(email: string) {
  const emp = this.Employees.find(e => e.email === email);
  if (emp) {
    ;
        if(emp.departmentName.toLowerCase() == 'industrial'){
          this.isIndustrialFunction = true;
          this.showHeadHR = true;
          this.showPlantMngr = true;
          this.showHRBP = false;
        }
        else{
          this.isIndustrialFunction = false;
          this.showHeadHR = false;
          this.showPlantMngr = false;
          this.showCurrentFuncDir = true;
          console.log("Is Industrial Function?" ,this.isIndustrialFunction)
        }
    this.employeeFullName = `${emp.firstName} ${emp.lastName}`;
    this.employeeFunction = emp.departmentName;
    this.employeeUnit = emp.functionName;   
    this.employeeLocation = emp.locationName;
    this.currentUnitHead = '';
    this.currentManager = '';
    this.employeeCurrentDesignation = '';
    this.rotationStartDate = null;
    this.rotationEndDate =null;
    this.newDesignation = '';
    this.receivingFunction = '';
    this.receivingLocation = '';
    this.receivingUnit = '';
    this.receivingManager = '';
    this.receivingUnitHead = '';
    this.newSection = '';

  }
}

onReceivingFunctionChange(functionName: string){
  ;
  if (this.employeeFunction.toLowerCase() == functionName.toLowerCase()){

        this.isSameFunction = true;

        if (this.isSameFunction && !this.isIndustrialFunction){
          this.showHRBP = true;
          this.showReceivingFuncDir = false;
          this.showOHRD = false;
        }

  }
    else{
      this.isSameFunction = false;
      this.showHRBP = true;
        this.showReceivingFuncDir = true;
        this.showOHRD = true;
    }
  console.log("Same Function?:", this.isSameFunction)
}

onReceivingLocationChange(location: string){
  ;
  if (this.employeeLocation.toLowerCase() == location.toLowerCase()){
    this.isSameLocation = true;

        this.showOHRD = false;

        if (this.isSameLocation && !this.isSameFunction){
          this.showOHRD = true;
        }

        if(this.isSameFunction && this.isSameLocation){
          this.showReceivingFuncDir = false;
        }

        if(this.isIndustrialFunction && this.isSameLocation){
          this.showHeadHR = true;
          this.showPlantMngr = true;
        }
        else{
          this.showHeadHR = false;
          this.showPlantMngr = false;
        }
  }
  else{
    ;
    this.isSameLocation = false;

    if (this.isSameFunction && !this.isSameLocation){
      this.showReceivingFuncDir = false;
      this.showOHRD = true;
      this.isSameFunction = true;
    }

    if(this.isSameFunction){  
      this.showReceivingFuncDir = false;
    }

    if(this.isIndustrialFunction && !this.isSameLocation){
      this.showHeadHR = true;
      this.showPlantMngr = true;
      //.showCurrentFuncDir = true;
      this.showReceivingFuncDir = true;
      this.showOHRD = true;
    }
    if(this.isIndustrialFunction && !this.isSameFunction){
      this.showCurrentFuncDir = true;
      this.showHeadHR = false;
      this.showHRBP = true;
      this.showPlantMngr = false;
      this.showReceivingFuncDir = true;
      this.showOHRD = true;
    }

  }
  console.log("Same Location?:", this.isSameLocation)
}

onReceivingUnitChange(unit: string){
  if (this.employeeUnit.toLowerCase() == unit.toLowerCase()){
    this.isSameUnit = true;

    if (this.isSameFunction && this.isSameLocation && this.isSameUnit){
      this.showCurrentFuncDir = true;
      this.showReceivingFuncDir = false;
    }
    else{
      this.showCurrentFuncDir = false;
      this.showCurrentFuncDir = true;
    }

  }
  else{
    this.isSameUnit = false;
  }
  console.log("Same Unit?:", this.isSameUnit)
}

  onSubmit(): void {
    this.isSubmitting = true;
    ;

    if (this.isIndustrialFunction && this.isSameLocation) {
      this.currentFunctionalDirectorToApprove = "";
      this.receivingFunctionalDirectorToApprove = "";
      this.ohrdToApprove = "";
    }

    if (this.isSameFunction && this.isSameLocation){
      this.receivingManager = "";
      this.receivingUnitHead = "";
      this.receivingFunctionalDirectorToApprove = "";
      this.ohrdToApprove = "";
    }

    if (this.isSameFunction && !(this.isSameLocation)){
      this.receivingFunctionalDirectorToApprove = "";
    }

    ;
    let jobRotationForm: JobRotationRequest = {
      requesterName: this.requesterFullName,
      requesterDesignation: this.requesterDesignation,
      employeeName: this.employeeFullName,
      employeeEmail: this.employeeEmail,
      employeeFunction: this.employeeFunction,
      employeeUnit: this.employeeUnit,
      employeeCurrentDesignation: this.employeeCurrentDesignation,
      employeeLocation: this.employeeLocation,
      //rotationCategory: this.rotationCategory,
      rotationStartDate: this.rotationStartDate,
      rotationEndDate: this.rotationEndDate,
      receivingFunction: this.receivingFunction,
      receivingUnit: this.receivingUnit,
      receivingLocation: this.receivingLocation,
      currentManager: this.currentManager,
      currentUnitHead: this.currentUnitHead,
      receivingManager: this.receivingManager,
      receivingUnitHead: this.receivingUnitHead,
      headOfHROrIndustrialRelationsToApprove: this.headOfHROrIndustrialRelationsToApprove,
      plantManagerApprovalToApprove: this.plantManagerApprovalToApprove,
      currentFunctionalDirectorToApprove: this.currentFunctionalDirectorToApprove,
      hrbpForNonIndustrialToApprove: this.hrbpForNonIndustrialToApprove,
      receivingFunctionalDirectorToApprove: this.receivingFunctionalDirectorToApprove,
      currentSection: this.currentSection,
      newSection: this.newSection,
      newDesignation: this.newDesignation,
      ohrDirectorToApprove: this.ohrdToApprove
    }
    
    console.log(jobRotationForm);

    this.jobRotationService.createJobRotationRequest(jobRotationForm).subscribe(
      (response) => {
        if(response.requestSuccessful){
          this.notification.sendMessage({
            message: response.message,
            type: NotificationType.success
          });
          location.reload();
        } else {

            this.notification.sendMessage({
              message: response.message,
              type: NotificationType.error
            });
          this.isSubmitting = false;


          }
      }
    ), (err: any) => {
      this.notification.sendMessage({
        message: 'error! try again',
        type: NotificationType.error
      })
      console.log(err.error.message);
      this.isSubmitting = false;

    }
  }

  onCancel() {
    this.theForm.resetForm();
  }

}

